import { CustomFormTemplate } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  templateImportJson: string;
}

interface ResponseDataType extends CustomFormTemplate {
}

export const importCustomFormTemplateRequest = ({
                                                  token,
                                                  templateImportJson
                                                }: RequestParams): Promise<ResponseDataType> => {
  let templateImportJsonParsed: any;
  try {
    templateImportJsonParsed = JSON.parse(templateImportJson);
  } catch (error: any) {
    return Promise.reject(new Error(`Invalid JSON: ${ error.message }`));
  }

  return ApiServiceInstance.makeRequest(`/custom-form-template/import-json`, {
    method: 'POST',
    token,
    body: templateImportJsonParsed,
  });
};